import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const pagerCarrierEntityName = 'pagerCarrier';
export const pagerCarrierColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { domainName: {
        type: 'string-required',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
